import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { objTrangThaiPhuHuynhDefine } from "../../action-types/trang-thai-phu-huynh/ITrangThaiPhuHuynhActionTypes";
export const trangThaiPhuHuynhAction = {
    ...generateActions(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH"),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "LOAD_CHECKDANGKY_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "LOAD_CHECKDANGKY_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "INSERT_MULTIPLE_SUCCESS", (m: any) => NotifyHelper.Success("Inserted multiple items")),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "INSERT_MULTIPLE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "UPDATE_SUCCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "UPDATE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}